import React from 'react';
import { Flex, PlaceholderMessage } from '@infotrack/zenith-ui';
import { TopFiveTeamMemberRow } from './topFiveTeamMemberRow';
import { containerStyles } from './topFiveTeamMembers.styles';
import type { ITopFiveApiV2EndpointsTopFiveSharedModelsStaffTopFiveDto } from '@/api/models';

type TopFiveTeamMembersProps = {
  staffWithSameTopFiveItem: ITopFiveApiV2EndpointsTopFiveSharedModelsStaffTopFiveDto[];
  currentItemName: string;
};

export const TopFiveTeamMembers = ({
  staffWithSameTopFiveItem,
  currentItemName,
}: TopFiveTeamMembersProps) => {
  return (
    <Flex sx={containerStyles}>
      {staffWithSameTopFiveItem.length > 0 ? (
        staffWithSameTopFiveItem.map((staffItem, index) => (
          <TopFiveTeamMemberRow
            key={staffItem.staff?.id || index}
            staffItem={staffItem}
            currentItemName={currentItemName}
          />
        ))
      ) : (
        <PlaceholderMessage
          title="No team members"
          subtitle="No other team members have this item in their Top 5"
        />
      )}
    </Flex>
  );
};
